import { render, staticRenderFns } from "./ObecjtsDelete.vue?vue&type=template&id=89d226d8&"
import script from "./ObecjtsDelete.vue?vue&type=script&lang=js&"
export * from "./ObecjtsDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports